export const SkeletonElement = ({ type }) => {
    return (
        <div className={`skeleton ${type}`}></div>
    )
}